import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StyledModal } from './PhoneModal.styles';
import {
  ModalContainer,
  TopSection,
  CongratsText,
  PackageTitle,
  UnderlineSvg,
  GiftImage,
  BottomSection,
  RewardText,
  HighlightNumber,
  ActionButton,
  ButtonIcon,
  PhoneVerificationRewardWrapper,
  TextContent,
  CloseButtonWrapper,
} from './styles';
import CloseButton from '../../../common/CloseButton';
import { BenefitItem } from '@/services/types';
import { userBenefitsManager } from '@/utils/userBenefitsManager';
import { handleGoToCreation } from '@/hooks/useUserBenefits';

interface PhoneVerificationRewardModalProps {
  onClose: () => void;
  benefitsData?: BenefitItem[];
}

const PhoneVerificationRewardModal: React.FC<PhoneVerificationRewardModalProps> = ({ 
  onClose, 
  benefitsData 
}) => {
  const location = useLocation();
  const { t } = useTranslation();
  const [hasMarkedShown, setHasMarkedShown] = useState(false); // 防止重复标记

  // 计算手机号验证完成权益的总积分
  const phoneVerificationCredits = React.useMemo(() => {
    if (!benefitsData || benefitsData.length === 0) return 0; // 默认值

    // 这里可以根据实际的权益类型来过滤，暂时使用默认值
    const phoneVerificationBenefits = benefitsData.filter(benefit => benefit.type === 1); // type=1也是手机号验证权益
    if (phoneVerificationBenefits.length === 0) return 0; // 如果没有手机号验证权益，使用默认值

    return phoneVerificationBenefits.reduce((total, benefit) => total + benefit.credits, 0);
  }, [benefitsData]);

  useEffect(() => {
    // 🔥 关键改进：弹窗显示时立即标记为已显示，防止刷新页面重复显示
    // 但只标记一次，避免重复调用导致的循环
    if (!hasMarkedShown) {
      console.log('[PhoneVerificationRewardModal] 弹窗已显示，立即标记为已显示状态');
      userBenefitsManager.markPhoneVerificationRewardShown();
      setHasMarkedShown(true);
    }
  }, [hasMarkedShown]);

  return (
    <StyledModal
      open={true}
      onCancel={onClose}
      footer={null}
      width={508}
      centered
    >
      <PhoneVerificationRewardWrapper>
        <ModalContainer>
          {/* <CloseButtonWrapper>
            <CloseButton onClick={onClose} />
          </CloseButtonWrapper> */}
          <TopSection>
            <TextContent>
              <CongratsText>{t('rewardModal.congrats')}</CongratsText>
              <PackageTitle>{t('rewardModal.phoneVerificationReward')}</PackageTitle>
              <UnderlineSvg
                xmlns="http://www.w3.org/2000/svg"
                width="93"
                height="12"
                viewBox="0 0 93 12"
                fill="none"
              >
                <path
                  d="M1.00051 10.1328C16.648 5.22372 102.737 -6.35785 90.2891 8.23855"
                  stroke="#FF6D49"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </UnderlineSvg>
            </TextContent>
            <GiftImage />
          </TopSection>
          <BottomSection>
            <RewardText>
              <HighlightNumber>{phoneVerificationCredits / 10}</HighlightNumber> {t('rewardModal.creditsSuffix')}
            </RewardText>
            <ActionButton onClick={() => handleGoToCreation(location.pathname, onClose)}>
              {t('rewardModal.goCreate')}
              <ButtonIcon
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <g clipPath="url(#clip0_2618_432)">
                  <path
                    d="M13.9304 6.8957C13.9024 6.7137 13.8114 6.5387 13.6714 6.4197L8.33744 1.0857C8.01544 0.812697 7.53244 0.847697 7.25244 1.1697C7.00744 1.4567 7.00744 1.8837 7.25244 2.1707L11.3194 6.2377H0.875436C0.448436 6.2377 0.105436 6.5807 0.105436 7.0077C0.105436 7.4347 0.448436 7.7777 0.875436 7.7777H11.3194L7.25244 11.8447C6.95144 12.1457 6.95144 12.6287 7.24544 12.9297C7.54644 13.2307 8.02944 13.2307 8.33044 12.9367L13.7204 7.5537C13.8884 7.3787 13.9654 7.1337 13.9304 6.8957Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2618_432">
                    <rect
                      width="14"
                      height="14"
                      fill="transparent"
                      transform="matrix(-1 0 0 1 14.0005 0.000976562)"
                    />
                  </clipPath>
                </defs>
              </ButtonIcon>
            </ActionButton>
          </BottomSection>
        </ModalContainer>
      </PhoneVerificationRewardWrapper>
    </StyledModal>
  );
};

export default PhoneVerificationRewardModal;
